import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Script from "react-inline-script";
var SegmentSnippet = function(param) {
    var apiKey = param.apiKey;
    return /*#__PURE__*/ _jsx(Script, {
        children: '\n      !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t,e){var n=document.createElement("script");n.type="text/javascript";n.async=!0;n.src="https://cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(n,a);analytics._loadOptions=e};analytics.SNIPPET_VERSION="4.1.0";\n        analytics.load(\''.concat(apiKey, "');\n      }}();\n  ")
    });
};
var SegmentTestWrapper = {
    identify: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _analytics;
        (_analytics = window.analytics).identify.apply(_analytics, _to_consumable_array(args));
        if (window.testAnalytics) {
            var _testAnalytics;
            (_testAnalytics = window.testAnalytics).identify.apply(_testAnalytics, _to_consumable_array(args));
        }
    },
    track: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _analytics;
        (_analytics = window.analytics).track.apply(_analytics, _to_consumable_array(args));
        if (window.testAnalytics) {
            var _testAnalytics;
            (_testAnalytics = window.testAnalytics).track.apply(_testAnalytics, _to_consumable_array(args));
        }
    },
    page: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _analytics;
        (_analytics = window.analytics).page.apply(_analytics, _to_consumable_array(args));
        if (window.testAnalytics) {
            var _testAnalytics;
            (_testAnalytics = window.testAnalytics).page.apply(_testAnalytics, _to_consumable_array(args));
        }
    }
};
var SegmentWrapper = {
    identify: function(userId, traits, options, callback) {
        try {
            SegmentTestWrapper.identify(userId, traits, options, callback);
        } catch (_err) {
        /* ignored */ }
    },
    track: function(event, properties, options, callback) {
        try {
            SegmentTestWrapper.track(event, properties, options, callback);
        } catch (_err) {
        /* ignored */ }
    },
    page: function(category, name, properties, options, callback) {
        try {
            SegmentTestWrapper.page(category, name, properties, options, callback);
        } catch (_err) {
        /* ignored */ }
    }
};
export { SegmentSnippet, SegmentWrapper };
